// PEO Reports Types

/** Report ID for Active/Inactive Chapter Members (supports PDF download). */
export const REPORT_ID_ACTIVE_INACTIVE_CHAPTER_MEMBERS =
  '117ec8c9572f4807bd3eca50e09fdb65';

/** Report ID for Membership Year Final Report (preset Active/Inactive, supports PDF download). */
export const REPORT_ID_MEMBERSHIP_YEAR_FINAL =
  '936fe92b7956413cb7e1a561377833e7';

/** Report ID for Chapter Transaction Log (supports PDF download). */
export const REPORT_ID_CHAPTER_TRANSACTION_LOG =
  '8c522f866cb24fc0a4d656731faa36f4';

/** Report ID for Chapter Membership History (supports PDF download). */
export const REPORT_ID_CHAPTER_MEMBERSHIP_HISTORY =
  '718c8a2796af4c10b7a0b6154746b68d';

/** Report ID for Chapter Listing (supports PDF download). */
export const REPORT_ID_CHAPTER_LISTING = '13b3ccaa953746ae84aa516b05a6c8b0';

/** Report ID for Chapter Health (supports PDF download). */
export const REPORT_ID_CHAPTER_HEALTH = '78b0207c9240418281b3bb026592b731';

/** Report ID for Increase/Decrease by Chapter summary (supports PDF download). */
export const REPORT_ID_INCREASE_DECREASE_BY_CHAPTER =
  '5c22a25a655049c38fe11fd9e0ed4a63';

/** Report ID for Chapter Star report (PDF-only graph). */
export const REPORT_ID_CHAPTER_STAR = 'd9817ee0cc994995bd7a5352d4ac6f4e';

/** Report ID for Membership YoY (year-over-year comparison). */
export const REPORT_ID_MEMBERSHIP_YOY = '53341b1b44d04882b6f002420a6a10a2';

/** Report ID for International Representative Officers' Conference Report (PDF-only). */
export const REPORT_ID_INTERNATIONAL_REP_OFFICERS_CONFERENCE =
  'a1b2c3d4e5f64882b6f002420a6a10a3';

/** Report ID for Membership Graphs (PDF-only). */
export const REPORT_ID_MEMBERSHIP_GRAPHS = 'f2eda88ee43846c08635650ad2458dfd';

/** Report ID for Annual Report of Membership (Form 6, PDF-only). */
export const REPORT_ID_ANNUAL_REPORT_OF_MEMBERSHIP =
  '5e32019a321a46c8abc680b331112f16';

/** Report ID for Annual Report of Membership of Disbanded Chapters (PDF-only). */
export const REPORT_ID_ANNUAL_REPORT_OF_MEMBERSHIP_DISBANDED_CHAPTERS =
  'f14af90bd7d340cfa5b802c46d06ef76';

/** Report ID for Funds by S/P/D (PDF-only). */
export const REPORT_ID_FUNDS_BY_SPD = 'd4e8f1a26b3c4a5d9e7f0c1b2a394857';

/** Report ID for Foundation Funds Activity Statements (async PDF bulk download). */
export const REPORT_ID_FOUNDATION_FUNDS_ACTIVITY_STATEMENTS =
  'd739fa305a324b759a27d31e6c376caa';

/** Report ID for Foundation Transfer Letter (sync PDF). */
export const REPORT_ID_FOUNDATION_TRANSFER_LETTER =
  'a97294879d234fdba350d7aeaa277948';

/** Report ID for CF Exports (Foundation awardee export; PCE later). */
export const REPORT_ID_CF_EXPORTS = '0d5bd002914e459b8c3547939524f921';

/** Report ID for Local Chapter Officer Election Reporting (list only). */
export const REPORT_ID_LOCAL_CHAPTER_OFFICER_ELECTION =
  'b2ca67066c244ff3a8869cf3d926f9e1';

/** Report ID for S/P/D Del/Alternate Reporting (list only; requires spd_chapter_id and membership_year). */
export const REPORT_ID_SPD_DEL_ALTERNATE = 'c8a8add7efa746e594a7055503f53334';

/** Report ID for Leadership Listing (list only; position groups and/or individual positions). */
export const REPORT_ID_LEADERSHIP_LISTING = '69a410f3ccc840688f3a42aa806bc247';

/** Report ID for Missing Leadership Positions (vacant chapter and S/P/D seats). */
export const REPORT_ID_MISSING_LEADERSHIP = 'c4e8a1b27d5f4e3a9c6b0d1e2f3a4b5c';

/** Report ID for Chapter Giving Pyramid (sample amounts until gifts are classified). */
export const REPORT_ID_CHAPTER_GIVING_PYRAMID =
  'e8b14c2a6f3d4e5b9a7c1d0e4f6a8b2c';

/** Report ID for Memorial Report (list only; SPD-scoped, date range, member type filter). */
export const REPORT_ID_MEMORIAL_REPORT = 'dfb52aef55ea44209405ebbb6a925eb6';

/** Report ID for Class Report (list only; S/P/D Chapter Officers org-wide; international access only; no filters). */
export const REPORT_ID_CLASS_REPORT = '98de89026f3e48798d5a1745793f2623';

/** Report ID for SPD Years of Membership (anniversary milestones; SPD + membership year + multi-select). */
export const REPORT_ID_YEARS_OF_MEMBERSHIP_SPD =
  '03f1d1b2d6954ef58de31fd7a1aacd9b';

/** Resource Statistics: library document/bundle view & download aggregates (Excel export; date range). */
export const REPORT_ID_RESOURCE_STATISTICS = 'c17cb16ec3da44eeb3e86a6f35ac8507';

/** Report ID for Unaffiliate Report (formerly Recently Moved Members). */
export const REPORT_ID_RECENTLY_MOVED_MEMBERS =
  'e6af09931cb248f7bda942bf3b0bb372';

/** Report ID for S/P/D Socials List (required spd_chapter_id; CSV supported). */
export const REPORT_ID_SPD_SOCIALS_LIST = 'cef88a98da334710a2387b1efef33152';

/** Report ID for SSO List (SPD members + international EO appointees; optional as_of_date). */
export const REPORT_ID_SSO_LIST = 'e304ef38554c4686bdee128fd0f40dc3';

/** IRS-LC Full Summary (membership year = ending calendar year in API). */
export const REPORT_ID_IRS_LC_FULL_SUMMARY = 'c4a9294df65e4c0d93b877f72bd69c4b';

/** IRS-RG Full Summary (membership year = ending calendar year in API). */
export const REPORT_ID_IRS_RG_FULL_SUMMARY = '7fa54a733a824af992d7d11611c73d11';

/** ELF - Late Loans (borrower grain; DaysLate > 0). */
export const REPORT_ID_ELF_LATE_LOANS = '68cc5a10361d4af6ac112b281e1f5e70';

/** ELF - PayPal Activity Errors (activity row grain). */
export const REPORT_ID_ELF_PAYPAL_ACTIVITY_ERRORS =
  'f9c75295b1b5490e9386f2b73b886932';

/** ELF - PayPal Recent Activity (settlement grain, 30/60/90 lookback). */
export const REPORT_ID_ELF_PAYPAL_RECENT_ACTIVITY =
  'bff57d53c56d41d9a3f5e0e9a0b1f7dc';

/** ELF - Loan by status (optional status filter). */
export const REPORT_ID_ELF_LOANS_BY_STATUS = 'e5b3c649dcac46418863fdcdb25e4b3a';

/** ELF - Behind schedule (catch_up_amount > 0). */
export const REPORT_ID_ELF_BEHIND_SCHEDULE = '0b8bcf43ea484a478ca664d72085704b';

/** ELF - Unmatched / unapplied settlements. */
export const REPORT_ID_ELF_UNMATCHED_SETTLEMENTS =
  '8b585a85dcec4a58a345db590ed53159';

/** ELF - Maturing soon (optional days, default 90). */
export const REPORT_ID_ELF_MATURING_SOON = '6a0d573914ed4ec991633148919fb437';

/** ELF - Balances (active loans: principal, billed interest, accrued interest). */
export const REPORT_ID_ELF_BALANCES = 'c3e91a04b6d74f2a8e5c1d9b0f7a4e62';

/** Elf Balance Report: active loans with principal > 0. */
export const REPORT_ID_ELF_BALANCE_REPORT = '47952d869fbf4dd48235bd10cf52608f';

/** Row shape returned for Resource Statistics report `data` array. */
export interface ResourceStatisticsRow {
  document_name: string;
  category: string;
  sub_category: string;
  unique_views: number;
  unique_downloads: number;
  total_views: number;
  total_downloads: number;
}

export interface PEOReport {
  id: string;
  name: string;
  description: string;
  access_scope: 'international' | 'spd' | 'chapter' | 'none';
  is_international: boolean;
  group_type_name: string;
  group_name: string;
}

export interface LeadershipListingMetadata {
  organization_wide_supported: boolean;
  position_group_type_ids_disallowed_organization_wide: string[];
}

export interface MissingLeadershipMetadata {
  organization_wide_supported: boolean;
  position_group_type_ids: string[];
  position_role_ids: string[];
}

export interface ReportParameter {
  name:
    | 'as_of_date'
    | 'start_date'
    | 'end_date'
    | 'local_chapter_id'
    | 'spd_chapter_id'
    | 'status'
    | 'local_chapter_roles'
    | 'position_group_type_ids'
    | 'position_role_ids'
    | 'members'
    | 'only_disbanded'
    | 'years_ago_inactive'
    | 'membership_year'
    | 'transaction_types'
    | 'include_member_contact'
    | 'membership_year_target'
    | 'anniversary_years'
    | 'chapter_status'
    | 'library_category_id'
    | 'library_sub_category_id'
    | 'year'
    | 'fund_type_id'
    | 'mailing_mode'
    | 'allocation_scope'
    | 'group_by'
    | 'include_last_lock_date'
    | 'officer_election_type'
    | 'election_completion_filter'
    | 'organization_wide'
    | 'days';
  type: 'date' | 'string' | 'boolean' | 'number';
  required: boolean;
  description: string;
  default_value?: string;
}

export interface ReportColumn {
  field: string;
  label: string;
  width: number;
  type: 'string' | 'date' | 'number' | 'email' | 'boolean';
  align: 'left' | 'right' | 'center';
  sortable: boolean;
  filterable: boolean;
  visible: boolean;
  /** Optional: "lc" = only when SPD selected, "spd" = only when company-wide; empty = both */
  mode?: string;
}

export interface FundTypeOptionMetadata {
  id: string;
  name: string;
}

export interface BulkFundSkipRow {
  fund_id?: string;
  account_id?: string;
  fund_name?: string;
  reason?: string;
}

export interface BulkStatementSummary {
  type_id: string;
  type_name: string;
  year: number;
  as_of_date: string;
  prepared_at?: string;
  printed_count: number;
  mailing_mode?: string;
  allocation_scope?: string;
  skipped?: BulkFundSkipRow[];
  excluded_multi_type?: BulkFundSkipRow[];
  excluded_exclusive?: BulkFundSkipRow[];
}

export interface ReportMetadata {
  id: string;
  name: string;
  description: string;
  access_scope: string;
  is_international: boolean;
  parameters: ReportParameter[];
  columns: ReportColumn[];
  leadership_listing?: LeadershipListingMetadata;
  missing_leadership?: MissingLeadershipMetadata;
  fund_type_options?: FundTypeOptionMetadata[];
}

export interface ExecuteReportRequest {
  as_of_date?: string;
  start_date?: string;
  end_date?: string;
  local_chapter_id?: string;
  spd_chapter_id?: string;
  status?: string;
  local_chapter_roles?: string;
  position_group_type_ids?: string;
  position_role_ids?: string;
  organization_wide?: boolean;
  members?: string;
  only_disbanded?: boolean;
  years_ago_inactive?: number;
  membership_year?: number;
  /** IRS LC/RG full summary: membership year's ending calendar year (matches irs.year). Years of Membership: calendar year. */
  year?: number;
  /** Chapter Transaction Log: comma-separated slugs; omit when all types */
  transaction_types?: string;
  include_member_contact?: boolean;
  membership_year_target?: 'current' | 'next';
  anniversary_years?: string;
  /** Chapter Listing: "all" | "active" | "disbanded" | "merged" (default active) */
  chapter_status?: string;
  /** Resource Statistics: optional library category id */
  library_category_id?: string;
  /** Resource Statistics: optional library subcategory id */
  library_sub_category_id?: string;
  format?: 'json' | 'emails' | 'csv' | 'pdf';
  /** Officer Election Reporting: local_chapter | spd_chapter | reciprocity */
  officer_election_type?: string;
  /** Officer Election Reporting: all | completed | not_completed */
  election_completion_filter?: string;
  /** Foundation Funds Activity Statements */
  fund_type_id?: string;
  /** Foundation Funds Activity Statements: standard | mailing | final */
  mailing_mode?: string;
  /** Legacy; server derives from fund_type_id (multi_transfers → multi_all) */
  allocation_scope?: string;
  /** Funds List: none | fund_type | spd */
  group_by?: string;
  /** Funds List: include last Annual Activity Statement lock date column */
  include_last_lock_date?: boolean;
  /** ELF Maturing Soon (forward) / PayPal Activity Errors (lookback): 30 | 60 | 90 */
  days?: number;
}

export interface ReportAsyncEnqueueResponse {
  task_log_id: string;
  task_id: string;
}

export interface ReportExecutionStatusResponse {
  status: string;
  message?: string;
  download_url?: string;
  filename?: string;
  summary?: BulkStatementSummary;
}

export interface ExecuteReportResponse {
  report_id: string;
  report_name: string;
  executed_at: string;
  execution_time: number;
  row_count: number;
  parameters: ExecuteReportRequest;
  data: any[] | null;
  /** Officer Election Reporting: which column set matches the result shape */
  report_mode?:
    | 'lc'
    | 'spd'
    | 'spd_officers'
    | 'reciprocity_lc'
    | 'reciprocity_spd';
}

export interface EmailExportResponse {
  emails: string;
  count: number;
  delimiter: string;
}

export interface PEOReportListResponse {
  reports: PEOReport[];
}
